import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioBillingVersions, portfolioBillingVersionsURL, } from "../request/getPortfolioBillingVersions";
export function portfolioBillingVersionsKeyMaker(queryParams) {
    return [portfolioBillingVersionsURL(queryParams || undefined)];
}
const useGetPortfolioBillingVersions = makeHook(getPortfolioBillingVersions, portfolioBillingVersionsKeyMaker);
export default useGetPortfolioBillingVersions;
//# sourceMappingURL=useGetPortfolioBillingVersions.js.map